module.exports = __webpack_public_path__ + "static/media/lama-dai.1704f08a.jpg";